import * as Blockly from 'blockly/core';
import 'blockly/python';

Blockly.Blocks['globe_basket_calculator'] = {
    init: function () {

        //this.appendDummyInput('first_inp')
        //     .appendField(" Indicator Basket Calculator:   ")
        //this.appendDummyInput('newline');

        this.appendDummyInput("basket_input_1")
            .appendField("Outputs    ")

        // .appendField(new Blockly.FieldDropdown([
        //     ["Basket 1","basket1"],
        //     ["Basket 2","basket2"]]),  "basket_choice")

        this.appendStatementInput("do")

        this.setStyle('imagery');
        this.setPreviousStatement(true, null);
    },
}